import { FrontEndProcessingStepModel } from '@/app/features/products/common/utils';
import * as yup from 'yup';
import { frontendProcessingValidator } from '@ssar-app/domain';

export * from './address-validators';
export * from './common-validator-schemas';
export * from './date-format-validator';
export * from './field-content-validators';
export * from './gen-codes';

export const inputFileInformationStepValidator: yup.Schema<FrontEndProcessingStepModel> =
  frontendProcessingValidator.required();

export type LayoutRecord = Record<string, string>;
